import { Box, Container, Link, Typography } from '@mui/material';

import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../context/AuthContext';
import { PAGES_URLS } from '../../lib/constants/routes';

function Footersocket() {
	const navigate = useNavigate();
	const { isAuthenticated } = useAuthentication();
	const date = new Date();
	return (
		<Box component={'section'} sx={{ mt: isAuthenticated ? '2rem' : 0, flexGrow: 1, backgroundColor: 'secondary.main', color: 'common.white', padding: '1rem' }}>
			<Container sx={{ marginTop: 0 }}>
				<Grid
					xs={12}
					container
					justifyContent='space-between'
					alignItems='center'
					flexDirection={{ xs: 'column', sm: 'row' }}
					sx={{ fontSize: '12px' }}
				>
					<Grid sx={{ order: { xs: 2, sm: 1 } }}>
						<Typography variant='subtitle2'>
							<Link sx={{ textDecoration: 'none', color: '#fff', cursor: 'pointer' }} href={'https://www.hessen-agentur.de/ '} target='_blank'>
								© HA Hessen Agentur GmbH {date.getFullYear()}
							</Link>
						</Typography>
					</Grid>
					<Grid container columnSpacing={2} sx={{ order: { xs: 1, sm: 2 } }}>
						<Grid>
							<Link
								variant='subtitle2'
								sx={{ textDecoration: 'none', color: '#fff', cursor: 'pointer' }}
								onClick={() => navigate(PAGES_URLS.Impressum)}
							>
								Impressum
							</Link>
						</Grid>
						<Grid>
							<Link
								variant='subtitle2'
								sx={{ textDecoration: 'none', color: '#fff', cursor: 'pointer' }}
								onClick={() => navigate(PAGES_URLS.Datenschutz)}
							>
								Datenschutz
							</Link>
						</Grid>

						<Grid>
							<Link
								variant='subtitle2'
								sx={{ textDecoration: 'none', color: '#fff', cursor: 'pointer' }}
								onClick={() => navigate(PAGES_URLS.BarrierefreiheitMelden)}
							>
								Barrierefreiheit melden
							</Link>
						</Grid>

						<Grid>
							<Link
								variant='subtitle2'
								sx={{ textDecoration: 'none', color: '#fff', cursor: 'pointer' }}
								onClick={() => navigate(PAGES_URLS.ErklaerungZurBarrierefreiheit)}
							>
								Erklärung zur Barrierefreiheit
							</Link>
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
}

export default Footersocket;
